<template>
  <div style="width: 100%;min-height: 100%;background:#f3f3f3;position:absolute;">
    <div class="mainCtn">
      <div class="title">
        <div @click="$router.push('/MyRSservices')" style="position:absolute;top:0px;left:0px;width: 200px;height:45px;line-height: 45px;font-size: 16px;color: #3A3A3A;cursor:pointer;font-weight: normal;text-align: left;">
          <span style="font-size: 18px;">＜</span> &nbsp;返回我的套件
        </div>
        标准版套件订单详情
      </div>
      <div style="width: 100%;height: auto;">
        <div class="progressBarCtn">
          <div class="progressBar">
            <!--圆1-->
            <div class="progressCircle_gray">
              <span>1</span>
              <div v-if="1 <= progressStat" class="progressCircle_blue">
                1
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  需求确认
                </div>
              </div>
            </div>
            <!--线1-->
            <div class="progressLine_gray">
              <div v-if="1 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆2-->
            <div class="progressCircle_gray">
              <span>2</span>
              <div v-if="2 <= progressStat" class="progressCircle_blue">
                2
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  订单提交
                </div>
                <div class="progressCircle_Text_time">
                  {{orderDetail.createTime}}
                </div>
              </div>
            </div>
            <!--线2-->
            <div class="progressLine_gray">
              <div v-if="2 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆3-->
            <div class="progressCircle_gray">
              <span>3</span>
              <div v-if="progressStat==3&&orderDetail.status!='已驳回'&&orderDetail.status!='已取消'" class="progressCircle_blue">
                3
              </div>
              <!--当步骤大于3（已交付），且未付款-->
              <div v-if="progressStat>3&&orderDetail.payStatus!='已付款'" class="progressCircle_red">
                3
              </div>
              <!--当步骤等于3，但已被驳回或取消-->
              <div v-if="progressStat==3&&(orderDetail.payStatus=='已驳回'||orderDetail.payStatus=='已取消')" class="progressCircle_red">
                3
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div  class="progressCircle_Text_name">
                  <span v-if="progressStat<3" style="color:#B8B8B8">
                      审核与支付
                  </span>
                  <span v-if="progressStat==3">
                    <span v-if="orderDetail.status=='已驳回'">审核未通过</span>
                    <span v-if="orderDetail.status=='已取消'">已取消</span>
                    <span v-if="orderDetail.status=='待确认'">合同待确认</span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='未付款'">合同已确认</span>
                    <span v-if="orderDetail.status=='待付款'&&orderDetail.contractStatus=='用户已确认'">合同已确认</span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='已付款'">已付款</span>
                  </span>
                  <span v-if="progressStat>3">
                    <span v-if="orderDetail.payStatus=='未付款'">
                      未付款
                    </span>
                    <span v-if="orderDetail.payStatus=='已付款'">
                      已付款
                    </span>
                  </span>
                </div>
                <!--时间-->
                <div v-if="progressStat>=3" class="progressCircle_Text_time">
                  <span v-if="progressStat==3">
                    <span v-if="orderDetail.status=='已驳回'">{{ orderDetail.contractConfirmTime }}</span>
                    <span v-if="orderDetail.status=='已取消'"></span>
                    <span v-if="orderDetail.status=='待确认'"></span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='未付款'">{{ orderDetail.contractConfirmTime }}</span>
                    <span v-if="orderDetail.status=='待付款'&&orderDetail.contractStatus=='用户已确认'">{{ orderDetail.contractConfirmTime }}</span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='已付款'">{{ orderDetail.payTime }}</span>
                  </span>
                  <span v-if="progressStat>3">
                    <span v-if="orderDetail.payStatus=='未付款'">
                    </span>
                    <span v-if="orderDetail.payStatus=='已付款'">
                      {{ orderDetail.payTime }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <!--线3-->
            <div class="progressLine_gray">
              <div v-if="3 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆4-->
            <div class="progressCircle_gray">
              <span>4</span>
              <div v-if="4 <= progressStat" class="progressCircle_blue">
                4
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  <span v-if="progressStat<4" style="color:#B8B8B8">
                    交付
                  </span>
                  <span v-else>
                    已交付
                  </span>
                </div>
                <!--已交付未下载-->
                <div  class="progressCircle_Text_time">
                  {{orderDetail.postTime}}
                </div>
              </div>
            </div>
            <!--线4-->
            <div class="progressLine_gray">
              <div v-if="4 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆5-->
            <div class="progressCircle_gray">
              <span>5</span>
              <div v-if="5 <= progressStat" class="progressCircle_blue">
                5
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  <span v-if="progressStat<5" style="color:#B8B8B8">
                    评价
                  </span>
                  <span v-else>
                    已评价
                  </span>
                </div>
                <div class="progressCircle_Text_time">
                  <span v-if="progressStat==5">
                    {{orderDetail.evaluateTime}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span class="payCtn">
         <div v-if="step==1" class="main-ctn" style="height:450px;">
            <div class="top">支付订单</div>
            <div class="titleBanner">
                支付方式
                <div class="titleBanner-right">
                  订单应付：￥ <span style="color:#0066CC;font-weight: bold">{{payFinal}}</span>
                </div>
            </div>
           <!--支付方式选择-->
            <div class="contentBanner" style="padding-top: 55px;padding-left: 10px;">
                <v-radio-group v-model="paySelect" row>
<!--                    <v-radio value="wx" style="width: 320px;">-->
<!--                        <template v-slot:label>-->
<!--                            <v-layout row>-->
<!--                                <img style="margin-left: 16px" src="../../assets/rsStandard/微信支付.png" height="40" width="139"/>-->
<!--                            </v-layout>-->
<!--                        </template>-->
<!--                    </v-radio>-->
                    <v-radio value="zfb" style="width: 320px;">
                        <template v-slot:label>
                            <v-layout row>
                                <img style="margin-left: 16px" src="../../assets/rsStandard/支付宝支付.png" height="43" width="121"/>
                            </v-layout>
                        </template>
                    </v-radio>
                    <v-radio value="dg" style="width: 320px;">
                        <template v-slot:label>
                            <v-layout row>
                                <img style="margin-left: 16px" src="../../assets/rsStandard/对公转账支付.png" height="44" width="164"/></v-layout>
                        </template>
                    </v-radio>

                </v-radio-group>
            </div>
           <!--确认支付-->
            <div style="width:1160px;height: 40px;margin-left: auto;margin-right: auto;margin-top: 50px;margin-bottom:50px;text-align: center">
                <div  @click="confirmPayment()" class="button1_confirm">
                    确认支付
                </div>
            </div>

        </div>
        <div v-if="step==2&&paySelect=='wx'" class="main-ctn">
            <div class="top">支付订单</div>
            <div class="titleBanner">
              <span @click="step=1" style="cursor:pointer;">＜返回</span> 请扫码支付，交易号:{{payId}}
                <div class="titleBanner-right">
                    订单应付：￥ <span style="color:#0066CC;font-weight: bold">{{payFinal}}</span>
                </div>
            </div>
            <div class="payTimeoutTip">
                请您在<span style="color:#006ca2">{{showCountDownTime}}</span>内完成支付
            </div>
            <div v-show="showReload" class="payTimeoutTip">
                请先刷新二维码再完成支付
            </div>
            <div class="payMainContent">
                <div class="qrCodeCtn">
                    <div class="top_qrCodeCtn">
                        <img :src="paymentQRCode" style="width:261px;height:261px; ">
                        <div v-show="showReload" @click="confirmPayment()" class="payCodeMantle">
                            <img src="../../assets/rsStandard/重新加载.png" height="72" width="72"/>
                        </div>
                    </div>
                    <div class="bottom_qrCodeCtn">
                        请使用微信扫一扫，扫描二维码支付
                    </div>
                </div>
                <div class="payTipCtn">
                    <img src="../../assets/rsStandard/卫星扫一扫.png" height="318" width="249"/>
                </div>
            </div>

        </div>
        <div v-if="step==2&&paySelect=='zfb'" class="main-ctn">
            <div class="top">支付订单</div>
            <div class="titleBanner">
              <span @click="step=1" style="cursor:pointer;">＜返回</span> 请扫码支付，交易号：{{payId}}
                <div class="titleBanner-right">
                    订单应付：￥ <span style="color:#0066CC;font-weight: bold">{{payFinal}}</span>
                </div>
            </div>
            <div v-show="!showReload" class="payTimeoutTip">
                请您在<span style="color:#006ca2">{{showCountDownTime}}</span>内完成支付
            </div>
            <div v-show="showReload" class="payTimeoutTip">
                请先刷新二维码再完成支付
            </div>
            <div class="payMainContent">
                <div class="qrCodeCtn">
                    <div class="top_qrCodeCtn">
                        <img :src="paymentQRCode" style="width:260px;height:260px; ">
                        <div v-show="showReload" @click="confirmPayment()" class="payCodeMantle">
                            <img src="../../assets/rsStandard/重新加载.png" height="72" width="72"/>
                        </div>
                    </div>
                    <div class="bottom_qrCodeCtn">
                        请使用支付宝扫一扫支付
                    </div>
                </div>
                <div class="payTipCtn">
                    <img src="../../assets/rsStandard/支付宝扫一扫.png" height="319" width="249"/>
                </div>
            </div>
        </div>
        <div v-if="step==2&&paySelect=='dg'" class="main-ctn">
            <div class="top">支付订单</div>
            <div class="titleBanner">
              <span @click="step=1" style="cursor:pointer;">＜返回</span> 对公转账流程
                <div class="titleBanner-right">
                    订单应付：￥ <span style="color:#0066CC;font-weight: bold">{{payFinal}}</span>
                </div>
            </div>
          <!-- 提示部分-->
            <div style="width: 1160px;background-color: rgba(0,102,153,0.05);;margin-left: auto;margin-right:auto;margin-top: 20px;border-radius: 6px;">
                <v-layout column>
                    <div style="margin-left: 19px;margin-top: 14px;font-size: 16px">温馨提示：</div>
                    <div style="margin-left: 19px;margin-top: 8px;font-size: 16px"> 1、财务会在3个工作日内审核并查账，如到账将会在1小时之内对您的订单进行排产，受银行处理时间影响，付款到账可能有所延误。 </div>
                    <div>
                        <v-layout row style="margin-bottom: 10px">
                            <div style="margin-left: 31px;margin-top: 8px;font-size: 16px">2、如果线下汇款过程中遇到任何问题可随时联系</div>
                            <div style="margin-top: 8px;font-size: 16px;color: #42A5F5;cursor: pointer" @click="dialog=true">商务经理</div>
                        </v-layout>
                    </div>
                </v-layout>
            </div>
          <!--对公详情-->
            <v-card flat tile style="margin-top: 48px;margin-left: 87px;width: 1160px;height: 600px">
                <v-layout row>
                    <!--侧边栏-->
                    <v-card flat tile style="height: 100%">
                        <v-layout align-center justify-center column fill-height>
                            <img height="36px" width="36px" src="../../assets/rsStandard/1.png">
                            <div style="float:left;margin-top: 12px;width: 1px;height: 350px; background-color: #BBBBBB;"></div>
                            <img style="margin-top: 13px" height="36px" width="36px" src="../../assets/rsStandard/2.png">
                            <div style="float:left;margin-top: 12px;width: 1px;height: 38px; background: darkgray;"></div>
                            <img style="margin-top: 12px" height="36px" width="36px" src="../../assets/rsStandard/3.png">
                        </v-layout>
                    </v-card>
                  <!-- 账户信息-->
                    <v-card flat tile style="margin-left: 21px;height: 100%">
                        <v-layout column>
                            <div style="font-size: 18px;margin-top: 4px">{{$vuetify.lang.t('$vuetify.payment.account')}}</div>
                            <div style="margin-top: 23px;font-size: 14px;color: #9B9B9B">转账途径&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#5F5F5F ">银行柜台转账、网上银行</span></div>
                            <div style="margin-top: 31px;font-size: 14px;color: #9B9B9B">收款户名&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#5F5F5F ">长光卫星技术股份有限公司</span></div>
                            <div style="margin-top: 31px;font-size: 14px;color: #9B9B9B">收款账号&nbsp;&nbsp;&nbsp;&nbsp;631326352</div>
                            <div style="margin-top: 31px;font-size: 14px;color: #9B9B9B">开户行名称&nbsp;&nbsp;&nbsp;&nbsp;中国民生银行长春一汽支行</div>
                            <div style="margin-top: 31px;font-size: 14px;color: #9B9B9B">开户行行号&nbsp;&nbsp;&nbsp;&nbsp;305241000033</div>
                            <div style="margin-top: 31px;font-size: 14px;color: #9B9B9B">汇款备注&nbsp;&nbsp;&nbsp;&nbsp;订单号+吉林一号遥感商城账户(手机号)</div>
                            <div style="margin-top: 27px;font-size: 14px;color: #F76161">请妥善保管汇款底单</div>
                            <div style="font-size: 18px;margin-top: 33px">提交汇款信息</div>
                            <v-layout row>
                                <div style="font-size: 14px;margin-top: 33px;margin-left: 12px;color: #9B9B9B">打款至长光卫星技术股份有限公司指定银行账号后，点击下方已完成汇款按钮，或联系</div>
                                <div style="font-size: 14px;margin-top: 33px;color: #42A5F5;cursor: pointer" @click="dialog=true">商务经理</div>
                                <div style="font-size: 14px;margin-top: 33px;color: #9B9B9B">提交您的汇款信息</div>
                            </v-layout>
                            <div style="font-size: 18px;margin-top: 37px">汇款结果反馈</div>
                            <v-layout row>
                                <div style="margin-top: 27px;margin-left: 12px;font-size: 14px;color: #9B9B9B">确定打款操作后，可以在</div>
                                <div style="margin-top: 27px;font-size: 14px;color: #42A5F5;cursor: pointer" @click="ToMyOrder()">我的套件</div>
                                <div style="margin-top: 27px;font-size: 14px;color: #9B9B9B">页面查看生产进度</div>
                            </v-layout>
                        </v-layout>
                    </v-card>

                </v-layout>
            </v-card>
          <!--已完成汇款-->
            <div style="width:1160px;height: 40px;margin-left: auto;margin-right: auto;margin-top: 50px;margin-bottom:50px;text-align: center">
                <div v-if="!confirmPay_dg" @click="confirmPayment_dg()"  class="button1_confirm">
                    已完成汇款
                </div>
                <div v-if="confirmPay_dg"  class="button1_confirm" style="background:#cccccc;width: 155px;">
                    等待商务经理确认
                </div>
            </div>

        </div>
        <!--支付成功-->
        <div v-if="step==3"  class="main-ctn">
            <div class="top">支付订单</div>
            <div class="successBanner" style="margin-top: 40px;">
                <img src="../../assets/rsStandard/订单提交成功_支付成功.png" height="52" width="52"/>
            </div>
            <div class="successBanner" style="margin-top: 10px;padding-left: 15px;">
                支付成功！
            </div>
            <div class="successContentCtn">
                <div style="width: 100%;height:30px;line-height: 30px;margin-top: 30px;">
                    <div style="float:left;width:470px;height:30px;line-height: 30px;text-align: right;">
                        支付方式：
                    </div>
                    <div style="float:left;width:489px;height:30px;line-height: 30px;text-align: left;padding-left: 25px">
                        <span v-if="payResult.type=='zfb'">支付宝</span>
                        <span v-else-if="payResult.type=='wx'">微信</span>
                        <span v-else>对公转账</span>
                    </div>
                </div>
                <div style="width: 100%;height:30px;line-height: 30px;margin-top: 12px;">
                    <div style="float:left;width:470px;height:30px;line-height: 30px;text-align: right;">
                        实付金额：
                    </div>
                    <div style="float:left;width:489px;height:30px;line-height: 30px;text-align: left;padding-left: 25px">
                        {{payResult.payFinal}} 元
                    </div>
                </div>
                <div style="width: 100%;height:30px;line-height: 30px;margin-top: 12px;">
                    <div style="float:left;width:470px;height:30px;line-height: 30px;text-align: right;">
                        预计交付时间：
                    </div>
                    <div style="float:left;width:489px;height:30px;line-height: 30px;text-align: left;padding-left: 25px">
                        即时交付
                    </div>
                </div>
            </div>
            <div style="width: 960px;height: 1px;border-bottom: 1px dashed #CCCCCC;margin-left: auto;margin-right: auto;margin-top: 55px;">

            </div>
          <!--查看订单-->
            <div style="width:1160px;height: 40px;margin-left: auto;margin-right: auto;margin-top: 50px;margin-bottom:50px;text-align: center">
                <div @click="$router.push('/MyRSservices')"  class="button1_confirm">
                    查看订单
                </div>
            </div>
        </div>
        <!--联系商务经理弹窗-->
        <div class="text-center" >
            <v-dialog
                v-model="dialog"
                width="660"
                height="300"
                z-index="1000000"
            >
                <v-card height="300" style="position:relative;width: 100%;padding: 1px;">
                    <!--关闭标签-->
                    <img style="position:absolute;top:0px;right:-60px;cursor: pointer"
                         src="../../assets/rsStandard/关闭弹窗.png" height="40" width="40"
                         @click="dialog=false"
                    />
                    <div style="height: 22px;font-size: 16px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;
                    color: #3A3A3A;line-height: 22px;text-align: center;margin-top: 100px;">
                        如遇到任何支付问题，请致电商务经理
                    </div>
                    <div style="height: 22px;font-size: 16px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 500;
                    color: #1D1D28;line-height: 22px;text-align: center;margin-top: 30px;">
                        0431-86008580
                    </div>
                    <div style="display:flex;justify-content:center;height:60px;width: 100%;margin-top: 30px">
                        <div @click="dialog=false"  class="applicationButton2" >
                            关闭
                        </div>
                    </div>

                </v-card>
            </v-dialog>
        </div>
      </span>
      <div class="bottomTip">
        若您有任何疑问请咨询商务经理：0431-86008580
      </div>

    </div>
    <HomeFooter1></HomeFooter1>
  </div>

</template>

<script>
import HomeFooter1 from "@comp/HomeFooter1.vue";
export default {
  name: "rsOrderPayment",
  components:{
    HomeFooter1
  },
  data(){
    return{
      orderId:'',
      orderDetail:{},
      progressStat:3,
      requirementId:'',
      step:1,//支付步骤
      paySelect: 'zfb',//付款方式选择
      dialog:false,//联系商务经理弹窗
      // 支付信息
      confirmPay_dg:false,
      paymentQRCode:'',//支付二维码
      payFinal:'',
      payId:'',
      //提示信息
      tipBar:false,
      tipTxt:'',
      //倒计时
      countDown_m:15,
      countDown_s:0,
      countDownTimer:{},
      showReload:false,
      showCountDownTime:'15:00',
      //支付结果
      payResult:{
      }
    }
  },
  methods:{
    ToMyOrder(){
      this.$router.push('/MyRSservice')
    },
    //获取订单详情（与进度条有关）
    getOrderDetail:function () {
      this.axios.get('/tilesapi/tiles/county/order/queryCountyOrderByOrderId?orderId='+this.orderId,
          {headers: {Authorization: "Bearer " + localStorage.getItem("token")}}
      ).then((res) => {
        console.log(res)
        if(res.data.code==200){
          this.orderDetail=res.data.data;
          this.payFinal=this.orderDetail.payFinal;
          //对公是否已点击付款
          if(this.orderDetail.payType=='dg'&&this.orderDetail.payStatus=='未付款'){
            this.confirmPay_dg=true;
          }
          let quarters=[];
          for(let i=0;i<this.orderDetail.repCountyList.length;i++){
            quarters.push(this.orderDetail.repCountyList[i].subName)
          }
          this.orderDetail.quarters=quarters;
          switch (this.orderDetail.status) {
            case '订单提交':
              this.progressStat=2;
              break;
            case '待确认':
              this.progressStat=3;
              break;
            case '已确认':
              this.progressStat=3;
              break;
            case '已驳回':
              this.progressStat=3;
              break;
            case '已取消':
              this.progressStat=3;
              break;
            case '已交付':
              if(this.orderDetail.evaluateStatus=='未评价'){
                this.progressStat=4;
              }
              else if(this.orderDetail.evaluateStatus=='已评价'){
                this.progressStat=5;
              }
              break;
            default:
              break;
          }
        }
      })
    },
    //初始化函数
    initialFun:function(){
      console.log("传参：")
      console.log(this.$route.query)
      if(this.$route.query.requirementId){
        this.requirementId=this.$route.query.requirementId;
        this.axios.get("/accessapi/getSaveProductDetail?requirementId=" + this.$route.query.requirementId)
            .then((res) => {
              console.log('订单详情')
              this.print(res)
              this.payFinal=res.data.data.payFinal;
              this.detailData = res.data.data;
              this.evaluateStatus=this.detailData.evaluateStatus
              // console.log('shortNames',shortNames)
              //配置订单进度条
              switch (this.detailData.status) {
                case'订单提交':
                  this.progressStat=2;
                  break;
                case '待确认':
                  this.progressStat=3;
                  break;
                case '生产中':
                  this.progressStat=3;
                  break;
                case '已交付'://已交付其他状态由html中vue判断语句区分
                  if(this.evaluateStatus){
                    //已评价
                    this.progressStat=5;
                  }else {
                    //未评价
                    this.progressStat=4;
                  }
                  break;
                case'已取消':
                  this.progressStat=3;
                  break;
                case'已驳回':
                  this.progressStat=3;
                  break;
                default:
                  this.progressStat=2;
                  break;
              }
              this.showOrderInfoList=false;
            })
      }
    },
    //15分钟倒计时函数
    countDownFun:function(){
      console.log("in countDownFun")
      console.log(this.countDown_s,this.countDown_m)
      this.countDown_s--;
      if(this.countDown_s<0){
        this.countDown_m--;
        this.countDown_s=59;
      }
      //当分和秒都为0，清除计时器
      if(this.countDown_m==0&&this.countDown_s==0){
        clearInterval(this.countDownTimer)
        //展示超时蒙层
        this.showReload=true;
        this.showCountDownTime='15:00'
        return;
      }
      let m=""
      let s=""
      if(this.countDown_m<10){
        m="0"+this.countDown_m
      }else {
        m=this.countDown_m
      }
      if(this.countDown_s<10){
        s="0"+this.countDown_s
      }
      else {
        s=this.countDown_s
      }
      this.showCountDownTime=m+":"+s
      this.getPayStatus();
    },
    //轮询用户支付状态
    checkPayStatus:function(){

    },
    //对公转账，点击已完成汇款
    confirmPayment_dg:function(){
      //初始化显示状态：提醒、倒计时、二维码蒙层
      this.tipBar=false;
      this.tipTxt="";
      if(this.countDownTimer){
        clearInterval(this.countDownTimer)
      }
      this.showReload=false;
      this.showCountDownTime="15:00"
      let resquestData={
        "type": this.paySelect,
        "requirementId": this.orderId,//订单号，saved_xxxx
      }
      this.axios
          .post(
              "/accessapi/pay/unionPay",
              resquestData,
              {
                headers: {
                  Authorization: this.getKey(),
                  "Content-Type": "application/json;charset=UTF-8",
                },
              }
          )
          .then((res) => {
            if(res.data.status==200){
              this.confirmPay_dg=true;
            }
            else {
              alert("服务器错误")
            }
          });
    },
    //点击支付，获取支付码，上传发票信息
    confirmPayment:function () {
      //初始化显示状态：提醒、倒计时、二维码蒙层
      this.tipBar=false;
      this.tipTxt="";
      if(this.countDownTimer){
        clearInterval(this.countDownTimer)
      }
      this.showReload=false;
      this.showCountDownTime="15:00"
      let resquestData={
        "type": this.paySelect,
        "requirementId": this.orderId,//订单号，saved_xxxx
      }
      //如果对公转账，则直接显示对公转账对应步骤2
      if(this.paySelect=='dg'){
        this.step=2;
        return;
      }
      this.axios.defaults.withCredentials = true;
      this.axios.post("/accessapi/pay/unionPay",
          {
            "type": this.paySelect,
            "requirementId": this.orderId,//订单号，saved_xxxx
          },
          {
            withCredentials: true,
            headers: {Authorization: "Bearer " + localStorage.getItem("token")}}
          )
          .then((res) => {
            if(res.data.status==200){
              this.paymentQRCode=res.data.data.QRCode;
              this.payFinal=res.data.data.payFinal;
              this.payId=res.data.data.payId;
              this.step=2;
              this.countDown_m=15;
              this.countDown_s=0;
              this.countDownTimer=setInterval(this.countDownFun,1000)
            }
            else {
              alert("服务器错误")
            }
          });
    },
    //查询支付状态
    getPayStatus:function(){
      this.axios
          .get(
              "/accessapi/pay/queryOrderPayStatus/"+this.payId,null,
              {headers: {
                  Authorization: this.getKey(),
                },}
          )
          .then((res) => {
            console.log("支付状态")
            console.log(res)
            if(res.data.status==200){
              if(res.data.data.status=="已付款"){
                clearInterval(this.countDownTimer)
                this.payResult=res.data.data;
                this.step=3;
              }
            }
          })
    },
    getKey() {
      return localStorage.getItem("token");
    },
  },
  mounted() {
    console.log("订单ID：")
    console.log(this.$route.params.orderId)
    this.orderId=this.$route.params.orderId;
    this.getOrderDetail();
    // this.initialFun();
    // this.getUserInvoiceIfm();

  },
  beforeDestroy(){
    if(this.countDownTimer){
      clearInterval(this.countDownTimer)
    }
  }
}
</script>

<style scoped lang="scss">
.payCtn{
  .orderDetailCtn {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    width: 1280px;
    height: 272px;
    border: 1px solid #CCCCCC;
    border-radius: 6px;
  }

  .progressButton {
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }

  .progressCircle_Text_time {
    width: 100%;
    text-align: center;
    height: 16px;
    line-height: 16px;
    font-weight: 500;
    color: #3A3A3A;
    font-size: 12px;
  }

  .progressCircle_Text_name {
    width: 100%;
    text-align: center;
    height: 20px;
    line-height: 20px;
    font-weight: 700;
    color: #3A3A3A;
    font-size: 16px;
  }

  .progressCircle_Text {
    position: absolute;
    top: 45px;
    left: -30px;
    width: 100px;
    height: auto;
  }
  .progressCircle_blue {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #006699;
    border-radius: 50%;
  }
  .progressCircle_red {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #FF4040;
    border-radius: 50%;
    font-size: 18px;
    color:#ffffff;
  }

  .progressLine_blue {
    z-index: 2;
    position: relative;
    left: -2px;
    top: 1px;
    width: 100px;
    height: 4px;
    background: #006699;
  }

  .progressLine_gray {
    position: relative;
    width: 100px;
    height: 6px;
    background: #CCCCCC;
    float: left;
    margin-top: 17px;
    margin-left: -1px;
  }

  .progressCircle_gray {
    position: relative;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 50%;
    background: #CCCCCC;
    float: left;
    margin-left: -1px;
    font-weight: 900;
    color: #FFFFFF;
  }

  .progressBar {
    position: absolute;
    right:0px;
    top:35px;
    width: 600px;
    height: 45px;
  }
  //.footer{
  //  margin-top: 100px;
  //  width: 100%;
  //  height: 100px;
  //  background: url("../../assets/rsStandard/footer.png");
  //  background-size: 100% 100%;
  //  background-repeat: no-repeat;
  //  background-blend-mode: multiply;
  //  line-height: 100px;
  //  font-size: 12px;
  //  font-family: PingFangSC-Regular, PingFang SC;
  //  font-weight: 400;
  //  color: #FFFFFF;
  //  text-align: center;
  //
  //}
  .applicationButton2{
    width: 96px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border-radius: 8px;
    font-size: 14px;
    color:#ffffff;
    background-color: #229BFF;
    cursor:pointer;
  }
  .v-expansion-panel::before {
    border-radius: inherit;
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
    transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
    transition-property: box-shadow;
    transition-duration: 280ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 0s;
    box-shadow: 0px 0px 1px 1px rgb(0 0 0 / 20%);
  }
  ::v-deep .v-dialog {
    overflow-y: inherit;
  }
  .tipBarClass{
    position:fixed;
    top:200px;
    left:50%;
    margin-left: -400px;
    width: 800px;
    height: 50px;
    background: #FF6666;
    box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.5);
    border-radius: 4px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    color:#ffffff;
    z-index:1000;
  }
  .successContentCtn{
    margin-top: 45px;
    margin-left: auto;
    margin-right: auto;
    width: 960px;
    height: 168px;
    background: rgba(0,102,153,0.05);
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #5F5F5F;
    padding-top: 1px;
  }
  .payTipCtn{
    margin-left: 45px;
    padding-left: 1px;
    width: 251px;
    height: 320px;
    border: dashed 1px #d4d4d4;
  }
  .qrCodeCtn{
    width: 262px;
    height: 320px;
    .top_qrCodeCtn{
      position:relative;
      width: 262px;
      height: 262px;
      /*border: 1px dashed #229bff;*/
    }
    .payCodeMantle{
      display: flex;
      justify-content: center;
      align-items: center;
      position:absolute;
      top:0px;
      z-index: 10;
      width: 100%;
      height:100%;
      background: rgba(255,255,255,0.8);
      cursor:pointer;
    }
    .bottom_qrCodeCtn{
      margin-top: 4px;
      width: 262px;
      height: 54px;
      background: #006699;
      line-height: 54px;
      text-align: center;
      color:#ffffff;
    }
  }
  .payMainContent{
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 50px;
    width: 1160px;
    height: 320px;
  }
  .inputStyle{
    width: 350px;
    height: 40px;
    color: #3A3A3A;
    background: #FFFFFF;
    border-radius: 6px;
    padding-left: 5px;
    font-size: 14px;
    border: 1px solid rgba(151,151,151,0.33);
    -webkit-appearance: none;
    appearance: none;
    outline: none;
  }
  .inputName{
    float:left;
    width: 100px;
    height: 45px;
    line-height: 45px;
    text-align: right;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    padding-right: 10px;
  }
  .inputCtn{
    float:left;
    width: 350px;
    height: 45px;
    line-height: 45px;
  }
  .inputContentBanner{
    width: 450px;
    height: 45px;
    margin-right: auto;
    margin-left: auto;
    margin-top:10px;
    .dashedLine{
      float:left;
      width:175px;
      height: 22px;
      border-bottom:1px dashed rgba(151,151,151,0.25);
    }
  }
  .invoiceContentCtn{
    position:relative;
    margin-left: auto;
    margin-right: auto;
    width: 1160px;
    height: auto;
    min-height: 100px;
  }
  .button1_confirm{
    display: inline-block;
    width: 150px;
    height: 40px;
    background: #006699;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 40px;
    cursor:pointer;
  }
  .invoiceItemText{
    margin-left: 16px;
    height: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 20px;
  }
  .componentMain{
    width: 100%;
    min-height: 100%;
    background: #F5F5F6;
  }
  .main-ctn{
    position:relative;
    margin-left: auto;
    margin-right: auto;
    margin-top: 100px;
    margin-bottom: 50px;
    padding-top: 1px;
    padding-bottom: 1px;
    width: 1280px;
    min-height: 500px;
    border-radius: 12px;
    background: #FFFFFF;
    .top{
      width: 1280px;
      height: 54px;
      background: rgba(0,102,153,0.75);
      border-radius: 12px 12px 0px 0px;
      line-height: 54px;
      text-align: center;
      color:#ffffff;
      font-size: 16px;
    }
    .contentBanner{
      position:relative;
      margin-left: auto;
      margin-right: auto;
      width: 1160px;
      height: 135px;
    }
    .payTimeoutTip{
      position:relative;
      margin-top: 30px;
      margin-left: auto;
      margin-right: auto;
      width: 1160px;
      height: 54px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3A3A3A;
      line-height: 54px;
      text-align: center;
    }
    .successBanner{
      position:relative;
      margin-left: auto;
      margin-right: auto;
      width: 1160px;
      height: 54px;
      text-align: center;
      line-height: 54px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #4A4A4A;
    }
    .titleBanner{
      position:relative;
      margin-top: 54px;
      margin-left: auto;
      margin-right: auto;
      width: 1160px;
      height: 54px;
      background: #F5F5F6;
      border-radius: 6px;
      padding-left: 19px;
      line-height: 54px;
      text-align: left;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1D1D28;
      .titleBanner-right{
        position:absolute;
        top:0px;
        right:0px;
        width: 200px;
        height: 54px;
        line-height: 54px;
        text-align: right;
        padding-right: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #979797;
      }
    }
  }
}
.bottomTip{
  margin-top: 80px;
  margin-bottom: 80px;
  height:25px;
  line-height: 25px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #3A3A3A;
}
.mainCtn{
  width: 1280px;
  min-height: 300px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  .title{
    margin-top: 126px;
    position:relative;
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    text-align: center;
  }
}
.progressButton {
  width: 150px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.progressCircle_Text_time {
  width: 100%;
  text-align: center;
  height: 16px;
  line-height: 16px;
  font-weight: 500;
  color: #3A3A3A;
  font-size: 12px;
}

.progressCircle_Text_name {
  width: 100%;
  text-align: center;
  height: 20px;
  line-height: 20px;
  font-weight: 400;
  color: #3A3A3A;
  font-size: 16px;
}

.progressCircle_Text {
  position: absolute;
  top: 38px;
  left: -30px;
  width: 100px;
  height: auto;
}

.progressCircle_blue {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #0066CC;
  border-radius: 50%;
}
.progressCircle_red {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #FF4040;
  border-radius: 50%;
  font-size: 18px;
  color:#ffffff;
}

.progressLine_blue {
  z-index: 2;
  position: relative;
  left: -2px;
  top: 1px;
  width: 186px;
  height: 4px;
  background: #0066CC;
}

.progressLine_gray {
  position: relative;
  width: 182px;
  height: 6px;
  background: #CCCCCC;
  float: left;
  margin-top: 14px;
  margin-left: -1px;
}

.progressCircle_gray {
  position: relative;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 50%;
  background: #CCCCCC;
  float: left;
  margin-left: -1px;
  font-weight: 900;
  color: #FFFFFF;
}

.progressBar {
  position: relative;
  width: 100%;
  height: 45px;
}

.progressBarCtn {
  width: 883px;
  height: 107px;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
}
::v-deep .v-dialog {
  overflow-y: inherit;
}
.applicationButton2{
  width: 96px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 8px;
  font-size: 14px;
  color:#ffffff;
  background-color: #229BFF;
  cursor:pointer;
}
</style>
